/**
 * @author PoornaChandu
 * @description  Planned Hours for Device  is Scheduled
 */
import React, { useState, useEffect } from 'react';
import { Tag, Select, Button, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const { Option } = Select;

const allWeekdays = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];
const PlannedHours = (props) => {
  const [inputTagVisible, setInputTagVisible] = useState(false);
  const [value, setValue] = useState(props.value || []);
  const [selectedWeekday, setSelectedWeekday] = useState(null);
  const [plannedHours, setPlannedHours] = useState(null);
  const [availableWeekdays, setAvailableWeekdays] = useState([]);
  let close = props.close || false;


  useEffect(() => {
    if (props.value !== undefined) {
      setValue(props.value);
    }

  }, [props.value]);

  useEffect(() => {
    if (value?.length === 0) {
      setAvailableWeekdays(allWeekdays);
      // setInputTagVisible(!inputTagVisible);
    } else {
      updateAvailableWeekdays();
    }
  }, [value]);
  useEffect(() => {
    if (value === null) {
      setValue([]);
    }
  }, [value]);
  
  useEffect(() => {
    if (close === true) {
      setSelectedWeekday(null);
      setValue([]);
    }
    setInputTagVisible(false);
  }, [close]);
  const updateAvailableWeekdays = () => {
    const usedWeekdays = value && Array.isArray(value) && value.map(item => item.split(': ')[0]);
    const remainingWeekdays = allWeekdays.filter(day => usedWeekdays && !usedWeekdays.includes(day));
    setAvailableWeekdays(remainingWeekdays);
  };

  const handleTagClick = () => {
    setInputTagVisible(!inputTagVisible);
  };

  const handleAddTag = () => {
    if (selectedWeekday && plannedHours >= 0 && plannedHours <= 24) {
      const newTag = `${selectedWeekday}: ${plannedHours} hours`;
      const newValue = [...value, newTag];
      setValue(newValue);
      props.addedTagList(selectedWeekday, plannedHours);

      setSelectedWeekday(null);
      setPlannedHours(null);
      setInputTagVisible(false);
    } else {
      message.warning('Please enter planned hours between 0 and 24.');
    }
  };

  const handleTagClose = (index) => {
    const newValue = [...value];
    newValue.splice(index, 1);
    setValue(newValue);
    props.closeTagList(newValue);
  };

  return (
    <div>
      <Tag
        onClick={!props?.formObject?.Id || !props?.disabled || props?.formEnabled ? handleTagClick : undefined}
        style={{
          borderStyle: 'dashed',
          cursor: props?.formObject?.Id || props?.disabled || props?.formEnabled ? 'not-allowed' : 'pointer',
          color: props?.formObject?.Id || props?.disabled || props?.formEnabled ? 'rgba(250, 250, 250, 0.97)' : undefined,
          pointerEvents: props?.formObject?.Id || props?.disabled || props?.formEnabled ? 'none' : 'auto',
        }}
      >
        <PlusOutlined /> Planned Hours
      </Tag>

      {inputTagVisible && (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 , width:600}}>
          <Select
            style={{ width: 180, marginRight: 8 }}
            placeholder="Select Weekday"
            value={selectedWeekday}
            onChange={setSelectedWeekday}
          >
            {availableWeekdays.map(day => (
              <Option key={day} value={day}>{day}</Option>
            ))}
          </Select>

          <Select
            value={plannedHours}
            onChange={(value) => setPlannedHours(value)}
            placeholder="Planned hrs Per Day"
            style={{ width: 230, marginRight: 8 }}
          >
            {Array.from({ length: 24 }, (_, i) => (
              <Option key={i + 1} value={i + 1}>
                {i + 1}
              </Option>
            ))}
          </Select>


          <Button type="primary" onClick={handleAddTag}>
            Add
          </Button>
        </div>
      )}

      {value && Array.isArray(value) &&
        value.map((tag, index) => {
          const isLongTag = tag.length > 20;
          return (
            <Tag
              color="blue"
              key={tag}
              closable
              onClose={() => handleTagClose(index)}
            >
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </Tag>
          );
        })}
    </div>
  );
};

export default PlannedHours;
